import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Zoom } from '@material-ui/core'

const Loader = () => {
  const classes = useStyles()
  const nodeRef = useRef(null)

  return (
    <Box className={classes.root}>
      <Zoom in style={{ transitionDelay: '200ms' }} ref={nodeRef}>
        <img
          className={classes.loader}
          alt='Go Bravo'
          src='./assets/images/go-bravo-logo.png'
        />
      </Zoom>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: theme.palette.background.default
  },
  loader: {
    width: 150,
    height: 'auto',
    margin: '0 auto'
  }
}))

export default Loader
